/**
 * Min wall dwell between successful house-embed loop-wrap advances.
 * Must stay below the on-air slot so short (1s) frames can wrap (#1382).
 */
export function houseEmbedLoopWrapMinDwellMs(slotMs: number): number {
  if (!(slotMs > 0)) {
    return 4000
  }
  return Math.max(400, Math.min(slotMs - 150, slotMs * 0.9))
}
